export const data = [
	{
		to: '/information',
		text: 'Information',
		id: 'Information',
	},
	{
		to: '/login',
		text: 'Log In',
	},
	{
		to: '/signup',
		text: 'Sign Up',
	},
];
